<template>
  <span :endTime="endTime">
    <slot>
      <div class="end-wrap" v-if="showEnd">{{ endText }}</div>
      <div class="time-wrap" v-else>
        距活动结束
        <span class="letter" v-if="day > 0">{{ day }}</span>
        {{ day > 0 ? "天" : "" }}
        <span class="letter">{{ hour }}</span
        >时 <span class="letter">{{ min }}</span
        >分
        <!-- <span class="letter">{{sec}}</span> -->
      </div>
    </slot>
  </span>
</template>
<script>
export default {
  name: "count-down",
  data() {
    return {
      hour: "00",
      min: "00",
      sec: "00",
      day: 0,
      endText: "加载中",
      showEnd: true,
      timer: null
    };
  },
  props: {
    endTime: {
      type: Date,
      default: ""
    }
  },
  mounted() {
    if (this.endTime) {
      this.init();
      this.countdown(this.endTime);
    }
  },
  watch: {
    endTime: {
      handler(val) {
        if (val) {
          clearInterval(this.timer);
          this.init();
          this.countdown(this.endTime);
        }
      }
    }
  },
  methods: {
    init() {
      this.hour = "00";
      this.min = "00";
      this.sec = "00";
      this.day = 0;
      this.endText = "加载中";
      this.showEnd = true;
    },
    countdown(timestamp) {
      let self = this;
      this.timer = setInterval(function() {
        let nowTime = new Date();
        let endTime = new Date(timestamp);
        let t = endTime.getTime() - nowTime.getTime();
        if (t > 0) {
          self.showEnd = false;
          let day = Math.floor(t / 86400000);
          let hour = Math.floor((t / 3600000) % 24);
          let min = Math.floor((t / 60000) % 60);
          let sec = Math.floor((t / 1000) % 60);
          hour = hour < 10 ? "0" + hour : hour;
          min = min < 10 ? "0" + min : min;
          sec = sec < 10 ? "0" + sec : sec;
          if (day > 0) {
            self.day = day;
            self.hour = hour;
            self.min = min;
            self.sec = sec;
          }
          if (day <= 0 && hour > 0) {
            self.day = 0;
            self.hour = hour;
            self.min = min;
            self.sec = sec;
          }
          if (day <= 0 && hour <= 0) {
            self.hour = "00";
            self.min = min;
            self.sec = sec;
          }
        } else {
          self.showEnd = true;
          self.endText = "商城活动已结束";
          clearInterval(this.timer);
        }
      }, 1000);
    },
    _callback() {
      if (this.callback && this.callback instanceof Function) {
        this.callback(...this);
      }
    }
  }
};
</script>
<style scoped>
.time-wrap {
  overflow: hidden;
  box-sizing: border-box;
  text-align: center;
  white-space: nowrap;
  text-align: right;
  margin-right: 20px;
}
.letter {
  display: inline-block;
  height: 24px;
  box-sizing: border-box;
  border-radius: 2px;
  padding: 0 3px;
  line-height: 24px;
  text-align: center;
  background-color: #fff1d1;
  color: #e64a3e;
  letter-spacing: 2px;
  margin: 0 3px 0 1px;
}
.end-wrap {
  text-align: right;
  color: #e64a3e;
  margin-right: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/countdown/index.vue